import Id from '@/models/util/entity/id'

export default class FKUId extends Id {}
